import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { VerticalKey } from '@/config/verticals'

export type DemoSectionKey =
  | 'logistics'
  | 'organization'
  | 'finance'
  | 'technology'
  | 'business_intelligence'

export const DEMO_SECTION_OPTIONS: Array<{ key: DemoSectionKey; label: string }> = [
  { key: 'logistics', label: 'Logística' },
  { key: 'organization', label: 'Organización' },
  { key: 'finance', label: 'Finanzas' },
  { key: 'technology', label: 'Tecnología' },
  { key: 'business_intelligence', label: 'Business Intelligence' },
]

type DemoSectionsByVertical = Partial<Record<VerticalKey, DemoSectionKey[]>>

interface DemoNavigationState {
  sectionsByVertical: DemoSectionsByVertical
  toggleSection: (vertical: VerticalKey, section: DemoSectionKey) => void
}

export const useDemoNavigationStore = create<DemoNavigationState>()(
  persist(
    (set) => ({
      sectionsByVertical: {},
      toggleSection: (vertical, section) => {
        set((state) => {
          const current = state.sectionsByVertical[vertical] ?? []
          const next = current.includes(section)
            ? current.filter((item) => item !== section)
            : [...current, section]
          return {
            sectionsByVertical: {
              ...state.sectionsByVertical,
              [vertical]: next,
            },
          }
        })
      },
    }),
    { name: 'aram-demo-navigation' }
  )
)
